export const GET_CMS_IMAGE_LINKS_FOOTER = "GET_CMS_IMAGE_LINKS_FOOTER";
export const GET_CMS_TEXT_LINKS_FOOTER = "GET_CMS_TEXT_LINKS_FOOTER";
export const GET_CMS_LOGO_SITIO_WEB_FOOTER = "GET_CMS_LOGO_SITIO_WEB_FOOTER";